// extracted by mini-css-extract-plugin
export default {"divider":"Toolbar-module__divider--Kctb6","toolbar":"Toolbar-module__toolbar--TBvFM","spacious":"Toolbar-module__spacious--TPl3v"};